import { store } from '../../core/store.js';
import { refs } from '../../core/refs.js';
import { escapeHtml } from '../../core/escape.js';
import { exportCode as buildStandaloneExport } from '../../core/wasm.js';
import { createZip } from './zip.js';

let exportDialogRegistered = false;
let exportServices = {
  console: null
};

export function configureExport(services = {}) {
  exportServices = {
    ...exportServices,
    ...services
  };
}

function sanitizeFileName(name, fallback = 'front-my-end-export') {
  const cleaned = String(name || '')
    .trim()
    .replace(/[/\\?%*:|"<>]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return cleaned || fallback;
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function buildSeparateHtml(title, html) {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${escapeHtml(title)}</title>
  <link rel="stylesheet" href="./styles.css">
</head>
<body>
${html}
  <script src="./script.js"></script>
</body>
</html>`;
}

function openExportDialog() {
  if (!refs.exportModal) {
    exportCode({ format: 'html', name: 'front-my-end-export' });
    return;
  }
  refs.exportModal.showModal();
  refs.exportNameInput?.focus();
  refs.exportNameInput?.select();
}

export function registerExportDialog() {
  if (exportDialogRegistered) return;
  exportDialogRegistered = true;

  refs.exportCancelBtn?.addEventListener('click', () => refs.exportModal?.close());
  refs.exportConfirmBtn?.addEventListener('click', () => {
    const name = sanitizeFileName(refs.exportNameInput?.value);
    const format = refs.exportFormatSelect?.value === 'zip' ? 'zip' : 'html';
    refs.exportModal?.close();
    exportCode({ name, format });
  });
}

export function exportCode(options = {}) {
  if (!options.format) {
    openExportDialog();
    return;
  }

  const html = store.get('html');
  const css = store.get('css');
  const js = store.get('js');
  const name = sanitizeFileName(options.name);

  if (options.format === 'zip') {
    const zip = createZip([
      { name: 'index.html', content: buildSeparateHtml(name, html) },
      { name: 'styles.css', content: css },
      { name: 'script.js', content: js }
    ]);
    downloadBlob(zip, `${name}.zip`);

    exportServices.console?.system(`Playground exported as ${name}.zip.`);
    return;
  }

  const exportedHtml = buildStandaloneExport(html, css, js);
  downloadBlob(new Blob([exportedHtml], { type: 'text/html' }), `${name}.html`);

  exportServices.console?.system(`Playground exported as ${name}.html.`);
}
